












































































































































































import {Component} from 'vue-property-decorator'
import FilterCurrent from '../components/FilterCurrent.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import ProductRow from '../components/Product/ProductRow.vue'
import {Product} from '@/models/Product'
import Helper from '../services/Helper.js'
import ListView from './ListView'

@Component({
  components: {FilterCurrent, LoadingDummy, ProductRow},
})
export default class ViewProduct extends ListView<Product> {
  // items: Product[] = []
  store = this.$store.state.products

  drawer_ratio = 0.2

  commit_prefix = 'products'
  base_url = Helper.setting.product.getListAPI


  display = 'column2'

  get column_no() {
    switch (this.display) {
      case 'list':
        return 1
      case 'column2':
        return 2
      case 'grid':
        return 4
    }
    return 1
  }

  get column_width() {
    return this.display_width / this.column_no
    // switch (this.display) {
    //   case 'list':
    //     return this.display_width/this.column_no;
    //   case 'column2':
    //     return 400
    //   case 'grid':
    //     return 200
    // }
  }
}
